import { render } from "./CompanyId.vue?vue&type=template&id=5249365a&scoped=true&ts=true"
import script from "./CompanyId.vue?vue&type=script&lang=ts"
export * from "./CompanyId.vue?vue&type=script&lang=ts"

import "./CompanyId.vue?vue&type=style&index=0&id=5249365a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5249365a"]])

export default __exports__